module.exports = __webpack_public_path__ + "static/media/Logo200.9e67f030.png";